/**
 * Created by jonas on 2022-05-30.
 */
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {PunkRockerIntroConfig} from "./intro/PunkRockerIntroConfig";

export class PunkRocker extends SlotGame {
    private _skinner: Skinner;

    constructor(gameModuleConfig: IGameModuleConfig) {
        super(gameModuleConfig);
        const validSkins: string[] = [
            "us-nonfree"    //gameClientConfiguration.replaceWordFree
        ]
        this._skinner = new Skinner(validSkins);
    }

    getNoWinGameData(): any {
        return {
            "reels": [
                [
                    "L1",
                    "L1",
                    "L1",
                    "L2",
                    "L2",
                    "L2",
                    "M3",
                    "M3"
                ],
                [
                    "L5",
                    "L4",
                    "M2",
                    "M1",
                    "M3",
                    "L5",
                    "L4",
                    "L4"
                ],
                [
                    "M4",
                    "M4",
                    "M4",
                    "L5",
                    "M5",
                    "M",
                    "M1",
                    "M1"
                ],
                [
                    "L2",
                    "L3",
                    "L4",
                    "L5",
                    "L5",
                    "M5",
                    "L4",
                    "L5"
                ],
                [
                    "L4",
                    "L4",
                    "M3",
                    "M2",
                    "M4",
                    "M4",
                    "M5",
                    "L1"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ]
            ],
            "evaluatedArea": [
                [
                    "L1",
                    "L1",
                    "L2",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "L4",
                    "M2",
                    "M1",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "M4",
                    "M4",
                    "L5",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "L3",
                    "L4",
                    "L5",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "L4",
                    "M3",
                    "M2",
                    "X",
                    "X",
                    "X"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ]
            ],
            "gameAreaSize": [
                3,
                3,
                3,
                3,
                3,
                3
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "totalSpinWinningsNonMultiplied": 0,
            "accumulatedRoundWin": 0,
            "reelsNextSpin": "BASE_REELSET",
            "playedBetValue": 100,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "nearWinReels": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "freespinTriggeredThisSpin": false,
            "reelsEnteringFreespin": [
                [
                    "L1",
                    "L1",
                    "L1",
                    "L2",
                    "L2",
                    "L2",
                    "M3",
                    "M3"
                ],
                [
                    "L5",
                    "L4",
                    "M2",
                    "M1",
                    "M3",
                    "L5",
                    "L4",
                    "L4"
                ],
                [
                    "M4",
                    "M4",
                    "M4",
                    "L5",
                    "M5",
                    "M",
                    "M1",
                    "M1"
                ],
                [
                    "L2",
                    "L3",
                    "L4",
                    "L5",
                    "L5",
                    "M5",
                    "L4",
                    "L5"
                ],
                [
                    "L4",
                    "L4",
                    "M3",
                    "M2",
                    "M4",
                    "M4",
                    "M5",
                    "L1"
                ],
                [
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X",
                    "X"
                ]
            ],
            "numberOfFreespinPlayed": 0,
            "freespinsLeft": 0,
            "payoutMultiplier": 1,
            "mysterySymbolOnReel": [
                false,
                false,
                false,
                false,
                false,
                false
            ],
            "mysterySymbolSize": [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "mysterySymbolRevealed": "",
            "mysterySymbolPositions": [
                -1,
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "mysterySymbolAppeared": false,
            "respinTriggered": false,
            "stickyWildPositions": "",
            "addedNumberOfFreespinsThisSpin": 0,
            "superXwayTrigger": false,
            "superXways": [
                0,
                0,
                0,
                0,
                0,
                0
            ],
            "freespinTrain": [
                "",
                "",
                "",
                "",
                "",
                ""
            ],
            "fsWildMultiplierPayout": [
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            ],
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN",
                    "type": "FREESPIN",
                    "price": 80
                },
                {
                    "name": "FREESPIN_BETTER",
                    "type": "FREESPIN",
                    "price": 238
                }
            ],
            "featureBet": false,
            "wasFeatureBuy": false
        };
    }

    getGameRules(): Promise<string> {
        return super.getGameRules().then((value: string) => {

            value = value.replace(new RegExp("#isGreece", "g"), (PunkRocker.api.gameClientConfiguration.jurisdictionName !== "GR" ? "isGreeceJur" : ""));
            return value;
        });
    }

    getPaytable(): Promise<string> {
        const data = Object.assign(PunkRocker.api.gameClientConfiguration);
        data.skinPath = "screens/images/";
        if (this._skinner.skinId != undefined) {
            data.skinPath = `../resources/images/${this._skinner.skinId}/`;
        }

        return super.getPaytable().then((value: string) => {
            value = value.replace(new RegExp("#isNOTUSJUR", "g"), (PunkRocker.api.gameClientConfiguration.useCensoredGfxUS ? "isNOTUSWV" : ""));
            value = value.replace(new RegExp("#isUSJUR", "g"), (PunkRocker.api.gameClientConfiguration.useCensoredGfxUS ? "" : "isUSWV"));
            return PunkRocker.api.translations.render(value, data);
        });
    }

    public async getReady(): Promise<NolimitPlugin> {
        const value: NolimitPlugin = await super.getReady();

        if (this._skinner.skinId != undefined) {
            const replaceMap: Map<string, string> = new Map();
            if (this._skinner.skinId === "us-nonfree") {
                replaceMap.set("Feature_Poster/Free_Spins", "Free_Spins.png");
                replaceMap.set("FREESPIN", "FREESPIN.png");
                replaceMap.set("FREESPIN_BETTER", "FREESPIN_BETTER.png");
                replaceMap.set(PunkRockerIntroConfig.INTRO_BG, "introBackground.png");
            }
            await this._skinner.loadSkin(replaceMap);
        }

        return value;
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((plugin: NolimitPlugin) => {
            //Making sure that skinID is set based  on "replaceWordFree" gcc.
            if (PunkRocker.api.gameClientConfiguration.isSet) {
                if (PunkRocker.api.gameClientConfiguration.replaceWordFree) {
                    this._skinner.skinId = "us-nonfree";
                }
            } else {
                PunkRocker.api.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                    if (PunkRocker.api.gameClientConfiguration.replaceWordFree) {
                        this._skinner.skinId = "us-nonfree";
                    }
                })
            }

            return plugin;
        });
    }
}